import React from 'react';
import cn from 'classnames';
import RatingScale from 'ui/RatingScale';
import RatingOptions from 'constants/rating-options';
import Text from 'components/shared/Text';

const GradingFeedback = ({ grade }) => {
  return (
    <div className="Card bg-gray-lightest p-16 d-f fd-c">
      <div className="d-f jc-c fz-16">
        <span className="fw-b">
          {t('demonstrations.progress.feedback_giver')}:
        </span>
        <span className="ml-8">
          {grade.grader && grade.grader.name
            ? grade.grader.name
            : t('demonstrations.progress.archived_user')}
        </span>
      </div>
      {grade.feedbackCriteriaRatings.length > 0 &&
        grade.feedbackCriteriaRatings.map(feedbackCriterionRating => (
          <div
            className="d-f mt-24 fz-14 pr-32 "
            key={feedbackCriterionRating.id}
          >
            <div className="d-f fd-c f-1">
              <div className="d-f fb-auto">
                <span className="w-fill wb-bw">
                  <Text lines={2} className="w-fill">
                    {feedbackCriterionRating.name}
                  </Text>
                </span>
              </div>
              <span className="d-f f-1 fb-auto jc-s mt-8">
                <RatingScale
                  ratingOptions={RatingOptions}
                  score={feedbackCriterionRating.rating}
                  setScore={_ => {}}
                  setHoverCount={_ => {}}
                  customClassName="mb-16 d-f fw-w"
                />
              </span>
            </div>
            <div className="d-f fd-c f-3 pl-32">
              <span className="fw-b">
                {RatingOptions.map(r => {
                  if (r.score !== feedbackCriterionRating.rating) {
                    return undefined;
                  }

                  return r.description;
                })}
                {!feedbackCriterionRating.rating &&
                  t('demonstrations.progress.no_rating_selected')}
              </span>
              <span
                className={cn('d-f f-3 fs-i mt-8 fb-auto', {
                  'c-gray-light': !feedbackCriterionRating.comment,
                })}
              >
                {feedbackCriterionRating.comment ||
                  t('demonstrations.progress.no_additional_comments')}
              </span>
            </div>
          </div>
        ))}
      <div className="mt-24 fz-14 pr-32">
        <div className="d-f fd-r">
          <div className="d-f f-1 jc-s">
            <span>{t('demonstrations.progress.feedback')}</span>
          </div>
          <div className="d-f f-3 pl-32">
            <span className="d-f f-3 fs-i">
              {grade.comment ||
                t('demonstrations.progress.no_additional_comments')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradingFeedback;
